// extracted by mini-css-extract-plugin
export default {"fullscreen":"ATMModal_fullscreen__Lgm3m"};